export default __webpack_public_path__ + "9ee782d0319477ad38542689b4cee534.png";